import { Document, Page, StyleSheet, Font, View, Text } from '@react-pdf/renderer'
import React, { FC } from 'react'

Font.register({
  family: 'myriad-pro',
  fonts: [
    {
      src: require('assets/fonts/myriad-pro-regular.woff'),
      fontWeight: 400
    },
    {
      src: require('assets/fonts/myriad-pro-semibold.woff'),
      fontWeight: 600
    },
    {
      src: require('assets/fonts/myriad-pro-bold.woff'),
      fontWeight: 700
    }
  ]
})

Font.registerHyphenationCallback(word => [word])

interface TitlePagePdfProps {
  organizationName: string
  accountName: string
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    paddingTop: '2.625in',
    paddingLeft: '1.75in',
    paddingBottom: '1.25in',
    paddingRight: '1.75in',
    fontFamily: 'myriad-pro',
    fontSize: '12pt',
    lineHeight: 1.6,
    wordWrap: 'break-word',
    maxWidth: '100%',
    textAlign: 'center'
  },
  header: {
    fontFamily: 'myriad-pro',
    fontSize: '26pt',
    lineHeight: 1.2,
    marginBottom: '1.75in',
    fontWeight: 600,
    wordWrap: 'break-word',
    maxWidth: '100%'
  },
  sectionSubtitle: {
    fontFamily: 'myriad-pro',
    fontSize: '17pt',
    lineHeight: 1.2,
    fontWeight: 500,
    wordWrap: 'break-word',
    maxWidth: '100%'
  }
})

const TitlePagePdf: FC<TitlePagePdfProps> = ({ organizationName, accountName }) => {
  return (
    <Document>
      <Page size='LETTER' style={styles.page}>
        <Text style={styles.header}>Comprehensive Media Plan</Text>

        <View style={{ marginBottom: '2.375in' }}>
          <Text style={styles.sectionSubtitle}>Prepared for {accountName}</Text>
        </View>

        <Text style={styles.sectionSubtitle}>A Client of {organizationName}</Text>
      </Page>
    </Document>
  )
}

export default TitlePagePdf
